import React from "react";
import { motion } from "framer-motion";
import { FaFilePdf, FaDownload } from "react-icons/fa";

import reportsHero from "../assets/Reports-cover-photo.jpg";
import annualReportCover from "../assets/annual-report-2025-26.png";
import auditReportCover from "../assets/audit-report-2025-26.png";

const Reports = () => {

  // ==========================================
  // ADD ANNUAL REPORTS HERE
  // ==========================================
  const annualReports = [
    {
    // title: "Annual Report 2025–26",
    // year: "2025–26",
    file: "/reports/ACoT-annaul-report-2025-26.pdf",
    cover: annualReportCover,
  },

    // Example for future reports
    /*
    {
      title: "Annual Report 2026–27",
      year: "2026–27",
      description:
        "Annual report covering the organisation's activities and achievements.",
      file: "/reports/annual-report-2026-27.pdf",
    },
    */
  ];


  // ==========================================
  // ADD AUDIT REPORTS HERE
  // ==========================================
  const auditReports = [
    {
    // title: "Audit Report 2025–26",
    // year: "2025–26",
    file: "/reports/ACoT-audit-report.pdf",
    cover: auditReportCover,
  },

    // Example for future reports
    /*
    {
      title: "Audit Report 2026–27",
      year: "2026–27",
      description:
        "Audited financial statements and financial records of ACoT.",
      file: "/reports/audit-report-2026-27.pdf",
    },
    */
  ];


  return (
    <div className="bg-black text-white min-h-screen">

      {/* ================= HERO ================= */}

      <section
        className="relative min-h-[55vh] flex items-center justify-center overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: `url(${reportsHero})`,
        }}
      >

        {/* Background Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Decorative circles */}
        <div className="absolute top-20 left-10 w-40 h-40 bg-lime-400/10 rounded-full blur-3xl"></div>

        <div className="absolute bottom-10 right-10 w-60 h-60 bg-lime-400/10 rounded-full blur-3xl"></div>


        <div className="relative z-10 text-center max-w-4xl mx-auto px-6">

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-lime-400 uppercase tracking-[0.3em] text-sm font-semibold mb-5"
          >
            Transparency & Accountability
          </motion.p>


          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl md:text-7xl font-bold mb-6"
          >
            OUR <span className="text-lime-400">REPORTS</span>
          </motion.h1>


          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 1,
              delay: 0.2,
            }}
            className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          >
            Explore our annual and audit reports to learn more about
            ACoT's work, progress, financial transparency and impact.
          </motion.p>

        </div>

      </section>


      {/* ================= ANNUAL REPORTS ================= */}

      <section className="py-20 bg-gray-950">

        <div className="w-11/12 md:w-4/5 mx-auto">

          {/* Heading */}

          <div className="text-center mb-14">

            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Our Progress
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              ANNUAL REPORTS
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

            {/* <p className="text-gray-400 mt-5 max-w-2xl mx-auto">
              Our annual reports provide an overview of our programmes,
              research, conservation activities, achievements and impact.
            </p> */}

          </div>


          {/* Annual Report Cards */}

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

            {annualReports.map((report, index) => (
              <ReportCard
                key={index}
                report={report}
                index={index}
              />
            ))}

          </div>

        </div>

      </section>


      {/* ================= AUDIT REPORTS ================= */}

      <section className="py-20 bg-black">

        <div className="w-11/12 md:w-4/5 mx-auto">

          {/* Heading */}

          <div className="text-center mb-14">

            <p className="text-lime-400 uppercase tracking-[0.25em] text-sm font-semibold mb-3">
              Financial Transparency
            </p>

            <h2 className="text-3xl md:text-4xl font-bold text-lime-400">
              AUDIT REPORTS
            </h2>

            <div className="w-20 h-1 bg-lime-400 mx-auto mt-5"></div>

            {/* <p className="text-gray-400 mt-5 max-w-2xl mx-auto">
              Our audit reports reflect our commitment to transparency,
              accountability and responsible financial management.
            </p> */}

          </div>


          {/* Audit Report Cards */}

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

            {auditReports.map((report, index) => (
              <ReportCard
                key={index}
                report={report}
                index={index}
              />
            ))}

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}

      <section className="relative py-20 bg-lime-400 text-black overflow-hidden">

        <div className="absolute -top-20 -right-20 w-72 h-72 bg-white/10 rounded-full"></div>

        <div className="absolute -bottom-20 -left-20 w-60 h-60 bg-black/5 rounded-full"></div>


        <div className="relative z-10 w-11/12 md:w-4/5 mx-auto text-center">

          <motion.h2
            initial={{
              opacity: 0,
              y: 30,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            className="text-3xl md:text-4xl font-bold mb-5"
          >
            Transparency Builds Trust
          </motion.h2>

          <p className="max-w-2xl mx-auto text-black/70 text-lg">
            We believe in maintaining transparency and accountability
            in every aspect of our work.
          </p>

        </div>

      </section>

    </div>
  );
};


// =====================================================
// REUSABLE REPORT CARD
// =====================================================

const ReportCard = ({ report, index }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 40,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.6,
        delay: index * 0.1,
      }}
      whileHover={{
        y: -8,
      }}
      className="group relative bg-gray-900 rounded-2xl overflow-hidden border border-gray-800 hover:border-lime-400/50 shadow-xl transition-all duration-300"
    >

      {/* Lime accent */}
      <div className="absolute top-0 left-0 w-full h-1 bg-lime-400 z-10"></div>

      {/* ================= COVER IMAGE ================= */}
      <div className="relative bg-gray-800 overflow-hidden">

        <img
          src={report.cover}
          alt={report.title}
          className="w-full h-auto max-h-[420px] object-contain mx-auto transition-transform duration-500 group-hover:scale-[1.03]"
        />

        {/* Hover overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition duration-300"></div>

      </div>


      {/* ================= CONTENT ================= */}
      <div className="p-7">

        {/* Year */}
        <p className="text-center text-lime-400 text-sm uppercase tracking-[0.2em] font-semibold mb-3">
          {report.year}
        </p>

        {/* Title */}
        <h3 className="text-xl font-bold text-white text-center mb-4">
          {report.title}
        </h3>

        {/* Description */}
        {report.description && (
          <p className="text-gray-400 text-sm text-center leading-relaxed mb-7">
            {report.description}
          </p>
        )}

        {/* Download */}
        <div className="flex justify-center">

          <a
            href={report.file}
            download
            className="inline-flex items-center gap-2 bg-lime-400 text-black px-6 py-3 rounded-full font-semibold hover:bg-lime-300 transition-all duration-300 shadow-lg"
          >
            <FaDownload size={15} />
            Download PDF
          </a>

        </div>

      </div>

    </motion.div>
  );
};


export default Reports;